import $ from 'jquery';
import 'slick-carousel';

$(function() {
    $('.before-after-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        dots: false,
        initialSlide: 1,
        rows: 0,
    });
    const switchToggle = $('.switch-button-checkbox');
    const switchToggleWrapper = $('.switch-button');
    switchToggle.change((e) => {
        e.preventDefault();
        if (e.target.checked) {
            switchToggleWrapper.addClass('checked');
            $('.before-after-carousel').slick('slickGoTo', 1);
        } else {
            switchToggleWrapper.removeClass('checked');
            $('.before-after-carousel').slick('slickGoTo', 0);
        }
    });
});
